export default __webpack_public_path__ + "static/media/excel-icon.4497d1c5.svg";